import { IconCapacity } from '@components/Icons/Icons';
import { subNav } from '@components/Navbar/SubNav';

export const navId = 'subNavContentCapacity';
const links = [
  {
    title: 'My DID-Groups',
    href: '/capacity/did-groups/existing',
    onlyCapacity: true,
    activePaths: ['/capacity/did-groups/:id/edit'],
  },
  {
    title: 'Add DID-Group',
    href: '/capacity/did-groups/new',
    onlyCapacity: true,
  },
  { title: 'Ded. Channels', href: '/capacity/dedicated-channels' },
  { title: 'Trunks', href: '/capacity/trunks' },
];
const capacitySubNav = () =>
  subNav({
    id: navId,
    title: 'Capacity',
    href: '/capacity',
    icon: IconCapacity,
    links,
  });

export default capacitySubNav;
